import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { RdoHttpService } from '@/app/core/http/rdo-http.service';
import { AuthenticationService } from '@/app/core/authentication/authentication.service';

@Injectable()
export class DownloadsGuardService {
  private hasAccess?: boolean;

  constructor(
    private authenticationService: AuthenticationService,
    private rdoHttp: RdoHttpService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const result =
      this.authenticationService._userInfoView.HasClientAccessToDownloads;

    if (result !== true) {
      this.router.navigate(['/summary']);
    }

    return of(result);
  }
}
